import {FormattedMessage, injectIntl} from "react-intl";
import CSSModules from "react-css-modules";
import styles from "./auth.scss";
import React from "react";
import PropTypes from "prop-types";
import classNames from 'classnames';
import {Timer} from "../components/timer/timer";

@injectIntl
@CSSModules(styles, {allowMultiple: true})
export class OtpForm extends React.Component {

  resentSmsTime = 60;

  constructor(props) {
    super(props);
    this.state = {
      digits: new Array(6).fill(''),
      isSendAgainAvailable: false,
      timerKey: 1,
    };
  }

  static propTypes = {
    phone: PropTypes.string,
    otpComplete: PropTypes.func,
    sendAgain: PropTypes.func,
    otpFocusAfterFail: PropTypes.func,
    isFail: PropTypes.bool,
    isSuccess: PropTypes.bool,
  };

  inputChanged(event, index) {
    if (!isNaN(event.target.value)) {
      const digitsCopy = [...this.state.digits];
      digitsCopy[index] = event.target.value;
      this.setState(state => {
        return {
          ...state,
          digits: digitsCopy,
        };
      });
      if (digitsCopy.every(value => !isNaN(value) && value.length === 1)) {
        event.target.blur();
        this.props.otpComplete(digitsCopy.join(''));
      } else if (event.target.value && index < 5) {
        event.target.nextSibling.focus();
      }
    }
  }

  onDigitFocus() {
    if (this.props.isFail) {
      this.setState(state => {
        return {
          ...state,
          digits: new Array(6).fill(''),
        };
      });
      this.props.otpFocusAfterFail();
    }
  }

  enableResend() {
    this.setState({
      ...this.state,
      isSendAgainAvailable: true,
    });
  }

  sendAgain() {
    if (this.state.isSendAgainAvailable) {
      this.setState(state => {
        return {
          ...state,
          timerKey: state.timerKey + 1,
          isSendAgainAvailable: false,
        };
      });

      this.props.sendAgain();
    }
  }

  render() {
    const className = classNames("digitInput", {validOtp: this.props.isSuccess}, {invalidOtp: this.props.isFail});

    return (
      <div>
        <div styleName="otpPlsEnter" data-at="otpPlsEnter">
          <FormattedMessage id="otp.form.plsEnter"/>
          <span>{this.props.phone}</span>

          <div styleName="digitsContainer">
            {this.state.digits.map((digit, index) => {
              return <input key={index}
                            data-at={'otpInput' + index}
                            onFocus={() => this.onDigitFocus()}
                            maxLength="1"
                            styleName={className}
                            max={9}
                            type="text"
                            onChange={(e) => this.inputChanged(e, index)}
                            value={this.state.digits[index] || ''}/>;
            })}
          </div>
          {this.props.isFail && <div styleName="otpErrorMessage">
            <FormattedMessage id="otp.form.invalidCode"/>
          </div>}
          <div styleName="timeForCode">
            <FormattedMessage id="otp.form.timeForCode"/>
          </div>
          <div styleName="noCodeWithTimer">
            <div styleName={this.state.isSendAgainAvailable ? "sendAgainLink" : 'sendAgain'} onClick={() => this.sendAgain()}>
              <FormattedMessage id="otp.form.didntGetCode"/>
            </div>
            <Timer key={this.state.timerKey}
                   time={this.resentSmsTime}
                   onTimerEnd={() => this.enableResend()}/>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/auth/OtpForm.js